import _ from 'underscore';
import { useEffect, useContext } from 'react';
import { getParameter } from '@bingads-webui/url-util';
import {
  triggerMultiStepTeachingBubbleWithLock,
  MultiStepTeachingBubbleContext,
} from '@bingads-webui-campaign-react/multi-step-teaching-bubble';
import { ReportingInsightsTeachingBubbleConfig } from './reporting-insights-teaching-bubble-config';

export function useReportingInsightsTeachingBubble(permissions) {
  const isReportingInsightsEnabled = _.get(permissions, ['dynamic', 'AdsCopilotReportingInsights']);
  const bubbleContext = useContext(MultiStepTeachingBubbleContext);
  const isTest = getParameter('testName') !== null || getParameter('ise2etest') !== null;

  useEffect(() => {
    if (isReportingInsightsEnabled && !isTest) {
      triggerMultiStepTeachingBubbleWithLock({
        ...bubbleContext,
        featureName: ReportingInsightsTeachingBubbleConfig.featureName,
      });
    }
  }, [bubbleContext, isReportingInsightsEnabled, isTest]);
}
